import * as Actions from '../actions/firmwareVersionUpdates.actions';

const initialState = [];

const firmwareVersionUpdates = (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GET_FIRMWARE_VERSION_UPDATES: {
      return action.payload;
    }
    case Actions.ADD_FIRMWARE_VERSION_UPDATES: {
      return [...state, action.payload];
    }
    case Actions.UPDATE_FIRMWARE_VERSION_UPDATES:
    case Actions.GET_FIRMWARE_VERSION_UPDATE:{
      const index = state.findIndex(
        (firmwareVersionUpdate) => firmwareVersionUpdate.id === action.payload.id
      );
      const newState = state;
      newState[index > -1 ? index : state.length] = action.payload;
      return [...newState];
    }

    default:
      return state;
  }
};

export default firmwareVersionUpdates;
